import { combineReducers } from "redux";
import view from "./view";

const chatBotReducer = combineReducers({
    view,
});

export default chatBotReducer;
